import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import CreativeLab from './facilities/CreativeLab'
import CommonHeader from './commonheader/CommonHeader'
import Footer from './Footer'
import EmbroideryUnit from './facilities/EmbroideryUnit'
import TailoringUnit from './facilities/TailoringUnit'
// import QualityControl from './facilities/QualityControl'
import ArchiveStudio from './facilities/ArchiveStudio'

const Facilities = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const target = document.querySelector(location.hash);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  }, [location]);

  return (
    <div>
      <CommonHeader />

      {/* IMPORTANT: id DOM wrapper pe hona chahiye */}
      <div id="creative-lab">
        <CreativeLab />
      </div>

      <div id="embroidery-unit">
        <EmbroideryUnit />
      </div>

      <div id="tailoring-unit">
        <TailoringUnit />
      </div>

      {/* 
      <div id="quality-control">
        <QualityControl />
      </div> 
      */}

      <div id="archive-studio">
        <ArchiveStudio />
      </div>

      <Footer />
    </div>
  )
}

export default Facilities
